import { createFileRoute } from "@tanstack/react-router";
import { TutorJoinPage } from "@/components/partners/TutorJoinPage";
import { tutorJoinHead } from "@/components/partners/tutor-join-head";

// «Для репетиторов и кружков» (az). Ссылка — только в подвале сайта.
export const Route = createFileRoute("/az/tutors/join")({
  head: () => tutorJoinHead("az"),
  component: () => <TutorJoinPage lang="az" />,
});
